import type {
  InputDescriptionProps,
  InputErrorProps,
  InputLabelProps,
  PinInputProps
} from '@mantine/core';
import { Input, PinInput } from '@mantine/core';
import React from 'react';

import styles from './OtpField.module.css';

interface OtpFieldProps extends PinInputProps {
  label?: InputLabelProps['content'];
  description?: InputDescriptionProps['content'];
  errorMessage?: InputErrorProps['content'];
}

export const LBOtpField = React.forwardRef<
  React.ElementRef<typeof PinInput>,
  OtpFieldProps
>(({ label, description, errorMessage, error, placeholder, ...props }, ref) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
    {label && <Input.Label className={styles.label}>{label}</Input.Label>}
    <PinInput
      error={!!errorMessage || error}
      {...props}
      ref={ref}
      classNames={styles}
      placeholder={placeholder || ''}
      type='number'
    />
    {description && <Input.Description>{description}</Input.Description>}
    {errorMessage && <Input.Error>{errorMessage}</Input.Error>}
  </div>
));
